export const SERVICE_NAME = 'pg-service-cart';

export const FAVORITES_LIST = 'FAVORITES_LIST';

export enum SHIPPING_METHODS {
    NAMED_DAY = 22,
    STANDARD = 11,
    SECOND_DAY = 12,
    OVERNIGHT = 13,
    STANDARD2 = 14,
    OVERNIGHT2 = 15,
    SATURDAY = 17,
    ELECTRONIC_SHIPPING = 99,
    BOPIS = 101,
    COURIER = 102,
    LOCAL_COLLECTION = 24,
    STORE_COLLECTION = 25,
    SELF_COLLECTION = 26,
    STANDARD_UPS = 1,
    COLISSIMO = 2,
    EXPRESS_CHRONOPOST = 3
}
